import React, { ReactNode } from "react";
import { Link as MuiLink, useTheme } from "@mui/material";
import type { LinkProps } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { dashboard2ManageColleaguesLinkSx } from "../dashboard2-status.styles";

type Dashboard2NavLinkProps = {
  to: string;
  label: string;
  ariaLabel: string;
  testId: string;
  icon?: ReactNode;
  sx?: SxProps<Theme>;
  underline?: LinkProps["underline"];
};

export const Dashboard2NavLink: React.FC<Dashboard2NavLinkProps> = ({
  to,
  label,
  ariaLabel,
  testId,
  icon,
  sx,
  underline
}) => {
  const theme = useTheme();

  return (
    <MuiLink
      component={Link}
      to={to}
      variant="inherit"
      underline={underline}
      aria-label={ariaLabel}
      sx={sx ?? dashboard2ManageColleaguesLinkSx(theme)}
      data-testid={testId}
    >
      {icon}
      {label}
    </MuiLink>
  );
};
